import * as Sentry from '@sentry/react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React, { createContext } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'

import App from './App.jsx'
import AuthProvider from './contexts/auth-context'

import { Toaster } from '@/components/ui/sonner'
// Initialize Sentry (Only once)
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_URL,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

export const AuthContext = createContext(null) // Or some initial state/object

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY) // starts with pk_

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      networkMode: 'always',
      refetchOnReconnect: true,
    },
  },
})

createRoot(document.getElementById('root')).render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
    <Elements stripe={stripePromise}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <Toaster position="top-right" richColors />

          <App />
        </QueryClientProvider>
      </AuthProvider>
    </Elements>
  </Sentry.ErrorBoundary>
)
